import React from "react";
import { Box, Container } from "@chakra-ui/react";
import { NavbarWithCallToAction } from "./chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "./chakra/FooterWithFourColumns/FooterWithFourColumns";

/**
 * ModuleLayout — wraps module pages with the standard navbar, container, and footer.
 *
 * Mirrors the master frontend's ModulePageLayout pattern: pages get a max-width
 * container so they don't span the full viewport width, plus consistent padding
 * and a flex layout that pushes the footer to the bottom.
 */
export const ModuleLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box minHeight="100vh" display="flex" flexDirection="column">
    <NavbarWithCallToAction />
    <Container maxW="container.xl" py={8} flex="1">
      {children}
    </Container>
    <FooterWithFourColumns />
  </Box>
);
